import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import axios from 'axios';

const TareasWidgetCuadrado = () => {
  const navigate = useNavigate();
  const { user, API } = useContext(AuthContext);
  const [tareasUrgentes, setTareasUrgentes] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user && (user.rol === 'profesor' || user.rol === 'estudiante' || user.rol === 'diploma' || user.rol === 'pastor' || user.rol === 'graduado')) {
      loadTareasUrgentes();
      
      // Actualizar cada 30 segundos
      const interval = setInterval(loadTareasUrgentes, 180000); // 3 minutos (antes 30 seg)
      return () => clearInterval(interval);
    } else {
      setLoading(false);
    }
  }, [user]);

  const loadTareasUrgentes = async () => {
    try {
      const response = await axios.get(`${API}/tareas/dashboard/proximas-vencer`);
      setTareasUrgentes(response.data.length);
    } catch (error) {
      console.error('Error al cargar tareas urgentes:', error);
      setTareasUrgentes(0);
    } finally {
      setLoading(false);
    }
  };

  // Solo mostrar si hay tareas urgentes
  if (loading || tareasUrgentes === 0) {
    return null;
  }

  return (
    <div
      onClick={() => navigate('/app/tareas')}
      className="group relative bg-gradient-to-br from-orange-500 via-red-500 to-pink-600 rounded-2xl p-6 cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-2xl overflow-hidden h-56"
    >
      {/* Efecto de brillo animado */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />
      
      {/* Contenido */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-white px-2">
        {/* Ícono con animación */}
        <div className="mb-2 transform group-hover:scale-110 transition-transform duration-300">
          <div className="relative">
            <i className="fas fa-tasks text-4xl drop-shadow-lg" />
            {tareasUrgentes > 0 && (
              <div className="absolute -top-1 -right-1 bg-white text-red-600 rounded-full w-6 h-6 flex items-center justify-center font-bold text-xs shadow-lg animate-pulse">
                {tareasUrgentes}
              </div>
            )}
          </div>
        </div>

        {/* Número grande */}
        <div className="text-5xl font-black mb-1 drop-shadow-lg">
          {tareasUrgentes}
        </div>

        {/* Texto descriptivo */}
        <div className="text-center">
          <p className="text-base font-bold drop-shadow-md">
            {tareasUrgentes === 1 ? 'Tarea Urgente' : 'Tareas Urgentes'}
          </p>
          <p className="text-xs font-medium opacity-90 mt-1">
            🔥 Vencen pronto
          </p>
        </div>

        {/* Indicador de clic */}
        <div className="mt-2 text-xs font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <i className="fas fa-arrow-right mr-1" />
          Click para ver
        </div>
      </div>

      {/* Decoración de fondo */}
      <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16" />
      <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/10 rounded-full -ml-12 -mb-12" />
    </div>
  );
};

export default TareasWidgetCuadrado;
